export const LISTS = 'Lists';
export const LISTS_APP_MEMBERSHIPS_LABEL = 'LABEL_MEMBERSHIPS';
